export const color = {
  grey900: '#1B1B1B',
  grey800: '#2B2B2B',
  grey700: '#434343',
  grey600: '#6E6E6E',
  grey500: '#999999',
  grey400: '#C4C4C4',
  grey300: '#E0E0E0',
  grey200: '#EDEDED',
  grey150: '#F2F2F2',
  grey100: '#F9F9F9',
  blue500: '#007DFF',
}

export const fontSize = {
  f11: '65px',
  f10: '54px',
  f9: '45px',
  f8: '38px',
  f7: '32px',
  f6: '26px',
  f5: '22px',
  f4: '20px',
  f3: '18px',
  f2: '16px',
  f1: '14px',
}
